import * as XLSX from "xlsx";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useForm } from "react-hook-form";
import { Link, useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";

//primeReact
import { Row } from "primereact/row";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { FilterMatchMode } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
import { ColumnGroup } from "primereact/columngroup";
import { SplitButton } from "primereact/splitbutton";
import { confirmDialog } from "primereact/confirmdialog";
import { InputTextarea } from "primereact/inputtextarea";
//components
import { formatCurrency } from "../../../../utils/formatCurrency";
import { parseCurrency } from "../../../../utils/parseCurrency";

//gets
import { getLands } from "../../../../services/GlobalRoles/getLands";
import { getBlocks } from "../../../../services/GlobalRoles/getBlocks";
import { getInvestors } from "../../../../services/GlobalRoles/getInvestors";
//components
import ModalEditLands from "./ModalEditLand";
import ModalCreateLands from "./ModalCreateLands";
import ModalDeleteBlocks from "./ModalDeleteBlocks";
import Modal from "../../../../components/modal/Modal";
import Panel from "../../../../components/panel/panel";
import FileInput from "../../../../components/input/FileInput";
import NumberInput from "../../../../components/input/NumberInput";
import ExportTable from "../../../../components/button/ExportButton";
//services
import { putLands } from "../../../../services/Register/putLands";
import { getInfoLand } from "../../../../services/GlobalRoles/getInfoLand";
import { getAllLands } from "../../../../services/Register/getAllLands";
import { deleteLands } from "../../../../services/Register/deleteLands";
import { getInfoBlock } from "../../../../services/GlobalRoles/getInfoBlock";
import { getSchedules } from "../../../../services/GlobalRoles/getSchedules";
import { postSchedulesExcel } from "../../../../services/GlobalRoles/postSchedulesExcel";
import { getBlockWithoutLands } from "../../../../services/Register/getBlockWithoutLand";
import { postAvailableLand } from "../../../../services/Register/postAvailableLand";
import { postReservedLand } from "../../../../services/Register/postReservedLand";
import { postBlockedLand } from "../../../../services/Register/postBlockedLand";
import { postChangePriceLand } from "../../../../services/Register/postChangePriceLand";
//context
import { useAppContext } from "../../../../context/AppContext";
import usePermission from "../../../../hooks/usePermission";
import { postSoldLand } from "../../../../services/Register/postSoldLand";

export default function Register() {
  const { id } = useParams(); //get id
  const { state } = useLocation();
  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  //  // console.log(nomenclatures);

  usePermission("93");

  const items = [
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações do Empreendimento
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/dashboard"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const [visible, setVisible] = useState(false);
  const [isVisibleReserve, setIsVisibleReserve] = useState(false);
  const [visibleEditModal, setVisibleEditModal] = useState(false);
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [land, setLand] = useState({});
  const [lands, setLands] = useState(null);
  const [tableToExport, setTableToExport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedBlock, setSelectedBlock] = useState(0);
  const [registerBlock, setRegisterBlock] = useState(null);
  const [headerModal] = useState("Cadastrar");
  const [headerEditModal] = useState("Cadastrar");
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOptionTitle, setSelectedOptionTitle] = useState("");
  const [selectedOptionLabel, setSelectedOptionLabel] = useState("");
  const [selectedOptionPrefix, setSelectedOptionPrefix] = useState("");
  const [value, setValue] = useState("");

  const [sendRowData, setSendRowData] = useState([]);
  const [fileSelected, setFileSelected] = useState(null);
  const [visibleFileInput, setVisibleFileInput] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  const [modalTitle, setModalTitle] = useState([]);
  const [modalType, setModalType] = useState([]);
  const [isFunctionSchedule, setIsFunctionSchedule] = useState([]);

  const columns = [
    { field: "id", header: `ID ${nomenclature[1].value}` },
    { field: "block", header: nomenclature[0].value },
    { field: "land", header: `${nomenclature[1].value}` },
    { field: "metro", header: "M²" },
    {
      field: "status",
      header: "Status",

      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.status) {
          case 1:
            labelClass = "badge bg-teal"; // Adicione suas classes de estilo
            labelText = "Disponível";
            break;
          case 2:
            labelClass = "badge bg-danger"; // Adicione suas classes de estilo
            labelText = "Vendido";
            break;
          case 3:
            labelClass = "badge bg-dark"; // Adicione suas classes de estilo
            labelText = "Bloqueado";
            break;
          case 0:
            labelClass = "badge bg-warning"; // Adicione suas classes de estilo
            labelText = "Reservado";
            break;
          default:
        }

        // Renderiza a label com a classe de estilo apropriada
        return <span className={labelClass}>{labelText}</span>;
      },
    },
    {
      field: "value",
      header: "Valor",

      body: (rowData) => formatCurrency(rowData.value),
    },
    // { field: "reason_for_blocking", header: "Motivo Bloqueio" },
    { field: "obs", header: "Observação" },
  ];

  const headerDeleteModal = ({ handleDelete }) => {
    return (
      <>
        <div className="text-center">
          <Button
            rounded
            type="submit"
            severity="danger"
            label="Excluir"
            icon="fa-solid fa-trash"
            className="p-inputtext-sm me-2 m-auto w-50"
            onClick={handleDelete}
          />
        </div>
      </>
    );
  };

  //STATUS
  const confirm = (selectedOptionStatus) => {
    // console.log("Antes de Confirmar: " + selectedOptionStatus);
    confirmDialog({
      message: "Deseja fazer a alteração?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: (event) => accept(event, selectedOptionStatus),
    });
  };
  // FIM STATUS
  const confirmDeleteLand = (selectedOptionDelete) => {
    // console.log("Antes de Confirmar: " + selectedOptionDelete);
    confirmDialog({
      message: "Deseja fazer a exclusão?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: (event) => deleteLand(event, selectedOptionDelete),
    });
  };

  const OptionStatus = [
    ...(permissions?.includes("86")
      ? [
          {
            label: "Disponível",
            title: "Disponível", // Adicione um título personalizado aqui
            command: () => {
              handleOptionSelect("1");
              setModalType("1");
            },
          },
        ]
      : []),
    ...(permissions?.includes("85")
      ? [
          {
            label: "Reservado",
            title: "Reservado", // Adicione um título personalizado aqui
            command: () => {
              handleOptionSelect("0");
              setModalType("0");
            },
          },
        ]
      : []),
    ...(permissions?.includes("168")
      ? [
          {
            label: "Vendido",
            title: "Vendido", // Adicione um título personalizado aqui
            command: () => {
              handleOptionSelect("2");
              setModalType("2");
            },
          },
        ]
      : []),
    ...(permissions?.includes("83")
      ? [
          {
            label: "Bloqueado",
            title: "Bloqueado", // Adicione um título personalizado aqui
            command: () => {
              handleOptionSelect("3");
              setModalType("3");
            },
          },
        ]
      : []),
  ];

  const handleOptionSelect = (newOption) => {
    // Validação para aceitar apenas lotes disponíveis
    if (newOption === "0" || newOption === "3" || newOption === "2") {
      const existReservedOrBlocked = selectedCustomers.filter(
        (item) => item.status !== 1
      );
      if (existReservedOrBlocked.length > 0) {
        toast.warning("Selecione apenas lotes disponíveis");
        setDisabled(false);
        setLoading(false);
        return;
      }
    }
    if (newOption === "1" || newOption === "2") {
      confirm(newOption);
    } else {
      setIsVisibleReserve(true);
    }
  };

  const accept = async (event, selectedOptionStatus) => {
    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
    setDisabled(true);
    setLoading(true);
    const idsLands = selectedCustomers.map((item) => item.id);
    const objData = {
      lands_id: idsLands,
      enterprise_id: id,
      status: selectedOptionStatus,
    };
    let nameFunction;
    switch (selectedOptionStatus) {
      case "0":
        nameFunction = postReservedLand;
        objData.obs = value;
        break;
      case "1":
        nameFunction = postAvailableLand;

        break;
      case "2":
        nameFunction = postSoldLand;
        break;
      case "3":
        objData.reason_for_blocking = value;
        nameFunction = postBlockedLand;
        break;

      default:
        break;
    }
    try {
      const response = await nameFunction(objData);
      let updatedLands = [...lands];

      idsLands.forEach((id) => {
        const updatedIndex = updatedLands.findIndex((item) => item.id === id);
        if (updatedIndex !== -1) {
          updatedLands[updatedIndex].status = parseInt(selectedOptionStatus);
        }
      });

      const successMessage =
        response.success || "Dados atualizados com sucesso!";

      toast.update(notification, {
        render: successMessage,
        autoClose: 5000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      console.error("Ocorreu um erro:", error);
      toast.update(notification, {
        render: "Não foi possível realizar a ação.",
        autoClose: 2000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    } finally {
      setSelectedCustomers([]);
      form.reset({});
      setLoading(false);
      setDisabled(false);
      setValue("");
    }
  };

  const deleteLand = async (event) => {
    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
    setDisabled(true);
    setLoading(true);
    const idsLands = selectedCustomers.map((item) => item.id);
    const objData = {
      lands_id: idsLands,
      enterprise_id: id,
    };
    try {
      const response = await deleteLands(objData);
      await getLand(false);
      // let updatedLands = [...lands];

      // idsLands.forEach(id => {
      //   const updatedIndex = updatedLands.findIndex(item => item.id === id);
      //   if (updatedIndex !== -1) {
      //     delete updatedLands[updatedIndex];
      //   }
      // });

      const successMessage =
        response.success || "Dados atualizados com sucesso!";

      toast.update(notification, {
        render: successMessage,
        autoClose: 5000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      console.error("Ocorreu um erro:", error);
      toast.update(notification, {
        render: "Não foi possível realizar a ação.",
        autoClose: 2000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    } finally {
      setSelectedCustomers([]);
      form.reset({});
      setLoading(false);
      setDisabled(false);
      setValue("");
    }
  };

  //DELETE LAND
  const handleOptionDeleteLand = (newOption) => {
    if (selectedCustomers.length === 0) {
      toast.warning("Selecione ao menos um lote para exclusão");
      return;
    }
    confirmDeleteLand(newOption);
  };

  //PRICE
  const showOptionModal = (optionTitle) => {
    setSelectedOptionTitle(optionTitle);
  };

  const OptionPrice = [
    {
      label: "Valor por Percentual",
      title: "Valor por Percentual", // Adicione um título personalizado aqui
      command: () => {
        const existReservedOrBlocked = selectedCustomers.filter(
          (item) => item.status !== 1
        );
        if (existReservedOrBlocked.length > 0) {
          toast.warning("Selecione apenas lotes disponíveis");
          setDisabled(false);
          setLoading(false);
          return;
        }
        setSelectedOption("percentual");
        showOptionModal("Valor por Percentual (%)");
        setIsModalVisible(true);
        setSelectedOptionLabel("Valor em Percentual");
        setSelectedOptionPrefix("percen");
      },
    },
    {
      label: "Valor em reais",
      title: "Valor em Reais", // Adicione um título personalizado aqui
      command: () => {
        const existReservedOrBlocked = selectedCustomers.filter(
          (item) => item.status !== 1
        );
        if (existReservedOrBlocked.length > 0) {
          toast.warning("Selecione apenas lotes disponíveis");
          setDisabled(false);
          setLoading(false);
          return;
        }
        setSelectedOption("reais");
        showOptionModal("Valor em Reais (R$)");
        setSelectedOptionLabel("Valor (R$)");
        setSelectedOptionPrefix("reais");
        setIsModalVisible(true);
      },
    },
    {
      label: "Valor por metro",
      title: "Valor por Metro", // Adicione um título personalizado aqui
      command: () => {
        const existReservedOrBlocked = selectedCustomers.filter(
          (item) => item.status !== 1
        );
        if (existReservedOrBlocked.length > 0) {
          toast.warning("Selecione apenas lotes disponíveis");
          setDisabled(false);
          setLoading(false);
          return;
        }
        setSelectedOption("metro");
        showOptionModal("Valor Por Metro Quadrado (M²)");
        setSelectedOptionLabel("Valor do Metro (R$)");
        setSelectedOptionPrefix("reais");
        setIsModalVisible(true);
      },
    },
  ];

  const defaultValues = {
    desconto: "",
    parcelas: "",
    discounts: "",
    maxDiscounts: null,
    value_selecionado: null,
  };

  const form = useForm({ defaultValues });
  const errors = form.formState.errors;

  async function handleCalculateValue(data, event) {
    const landsWithNewPrices = selectedCustomers.reduce((acc, land) => {
      let newPrice;

      switch (selectedOption) {
        case "metro":
          newPrice = land.metro * data.value_selecionado;
          break;
        case "percentual":
          newPrice = land.value + land.value * (data.value_selecionado / 100);
          break;
        case "reais":
          newPrice = data.value_selecionado;
          break;
        default:
          newPrice = land.value;
          break;
      }

      acc[land.id] = newPrice; // Adiciona ao objeto acumulador
      return acc;
    }, {});

    // console.log(landsWithNewPrices);

    const objData = {
      enterprise_id: id,
      lands: landsWithNewPrices,
    };
    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );

    setDisabled(true);
    try {
      const response = await postChangePriceLand(objData);
      let updatedLands = [...lands];
      const idsLands = selectedCustomers.map((item) => item.id);

      idsLands.forEach((id) => {
        const updatedIndex = updatedLands.findIndex((item) => item.id === id);
        if (updatedIndex !== -1) {
          updatedLands[updatedIndex].value = parseFloat(landsWithNewPrices[id]);
        }
      });

      const successMessage =
        response.success || "Dados atualizados com sucesso!";

      toast.update(notification, {
        render: successMessage,
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      console.error("Ocorreu um erro:", error);
      toast.update(notification, {
        render: "Hm..Algo não ocorreu bem, verifique sua internet.",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    } finally {
      setDisabled(false);
      setSelectedCustomers([]);
      setIsModalVisible(false);
      form.reset({});
    }
    // setDisabled(false);

    // getLands() é chamado aqui para garantir que seja a última ação
    // await getLand(notification);
  }
  //END PRICE

  const handleCloseEditModal = () => {
    setVisibleEditModal(false);
  };

  const handleCloseDeleteModal = () => {
    setVisibleDeleteModal(false);
  };

  const onSelectionChange = (event) => {
    const value = event.value;
    // console.log(value);
    // console.log(totalRecords);
    setSelectedCustomers(value);
    setSelectAll(value.length === totalRecords);
  };

  const onSelectAllChange = (event) => {
    setSelectAll(event.checked);

    if (event.checked) {
      // Se o checkbox de seleção estiver marcado, selecionar todos os registros
      setSelectedCustomers(lands);
    } else {
      // Se o checkbox de seleção estiver desmarcado, desmarcar todos os registros
      setSelectedCustomers([]);
    }
  };

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };

  const getLand = async (isNotify = true) => {
    // console.log(selectedBlock);
    if (selectedBlock === 0) {
      setLoading(true);
      let notification;
      if (isNotify) {
        notification = toast.loading(
          "Por favor aguarde a consulta está sendo realizada..."
        );
      }
      try {
        const response = await getAllLands(id);

        setTotalRecords(response.length);
        const data = response.map((dado) => ({
          id: dado.id,
          block: dado.block,
          land: dado.land,
          metro: dado.m2,
          status: dado.status,
          value: dado.value,
          address: dado.address,
          num_register: dado.num_register,
          city_hall_register: dado.city_hall_register,
          front_measurement: dado.front_measurement,
          bottom_measurement: dado.bottom_measurement,
          left_measurement: dado.left_measurement,
          right_measurement: dado.right_measurement,
          corner_measurement: dado.corner_measurement,
          front_confrontation: dado.front_confrontation,
          bottom_confrontation: dado.bottom_confrontation,
          left_confrontation: dado.left_confrontation,
          right_confrontation: dado.right_confrontation,
          others_confrontation: dado.others_confrontation,
          descriptive_memorial: dado.descriptive_memorial,
          obs: dado.obs,
          booked_by: dado.booked_by,
          created_at: dado.created_at,
          updated_at: dado.updated_at,
          block_id: dado.id_block,
        }));
        // console.log(response)
        setLands(data);
        setLoading(false);
        setShowTable(true);
        toast.update(notification, {
          render: "Consulta realizada!",
          autoClose: 1000,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      } catch (error) {
        //        console.log(error);
        setLoading(false);
        if (notification) {
          toast.update(notification, {
            render: "Hm..Algo não ocorreu bem, verifique sua internet.",
            autoClose: 1000,
            theme: "colored",
            type: "error",
            isLoading: false,
          });
        }
      }
    } else {
      setLoading(true);
      const notification = toast.loading(
        "Por favor aguarde a consulta está sendo realizada..."
      );
      try {
        const response = await getInfoBlock(selectedBlock);
        const block = response.name;
        const block_id = response.id;
        const data = response.lands.map((dado) => ({
          id: dado.id,
          block: block,
          land: dado.name,
          metro: dado.m2,
          status: dado.status,
          value: dado.value,
          address: dado.address,
          num_register: dado.num_register,
          city_hall_register: dado.city_hall_register,
          front_measurement: dado.front_measurement,
          bottom_measurement: dado.bottom_measurement,
          left_measurement: dado.left_measurement,
          right_measurement: dado.right_measurement,
          corner_measurement: dado.corner_measurement,
          front_confrontation: dado.front_confrontation,
          bottom_confrontation: dado.bottom_confrontation,
          left_confrontation: dado.left_confrontation,
          right_confrontation: dado.right_confrontation,
          others_confrontation: dado.others_confrontation,
          general_confrontation: dado.general_confrontation,
          obs: dado.obs,
          booked_by: dado.booked_by,
          created_at: dado.created_at,
          updated_at: dado.updated_at,
          block_id: block_id,
        }));

        data.sort((a, b) => a.land.localeCompare(b.land));

        setLands(data);

        setLoading(false);
        setShowTable(true);

        toast.update(notification, {
          render: "Consulta realizada!",
          autoClose: 1000,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      } catch (error) {
        //        console.log(error);
        setLoading(false);
        if (notification) {
          toast.update(notification, {
            render: "Hm..Algo não ocorreu bem, verifique sua internet.",
            autoClose: 1000,
            theme: "colored",
            type: "error",
            isLoading: false,
          });
        }
      }
    }
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  async function SubmitEditLand(land) {
    setLoadingModal(true);
    setVisibleEditModal(true);
    setLand(land);
    const response = await getInfoLand(land.id);
    setSendRowData(response);
    setLoadingModal(false);
    setVisibleEditModal(true);
  }

  const { data: schedules, refetch: refetchSchedule } = useQuery({
    queryKey: ["schedules"],
    queryFn: () => getSchedules(),
    // refetchOnWindowFocus: false,
    // retry: false,
    enabled: !!permissions?.includes("2"),
  });

  const {
    data: blocks,
    isLoading: isLoadingBlocks,
    refetch: blocksRefetch,
  } = useQuery("blocks", () => getBlocks(id), { retry: false });

  const { data: investors } = useQuery("investors", () => getInvestors());

  const { data: whiteBlocks, refetch: refetchBlock } = useQuery(
    "whiteBlocks",
    () => getBlockWithoutLands(id)
  );

  const totalValue = lands
    ? lands.reduce((total, land) => total + land.value, 0)
    : 0;

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column
          footer="Total:"
          colSpan={6}
          footerStyle={{ textAlign: "right" }}
        />
        <Column footer={formatCurrency(totalValue)} />
        <Column colSpan={3} footerStyle={{ textAlign: "right" }} />
      </Row>
    </ColumnGroup>
  );

  nomenclature[1].command = () => {
    if (selectedCustomers.length === 0) {
      toast.warning(`Selecione ao menos um ${nomenclature[1].value}`);
      return;
    }
    handleOptionDeleteLand("land");
  };

  nomenclature[0].command = () => {
    setVisibleDeleteModal(true);
  };

  const handleOption = async (title, isFunc) => {
    setIsFunctionSchedule(isFunc);
    setModalTitle(title);
    setVisibleFileInput(true);
  };

  const spreadsheet = [
    {
      label: `Nova ${nomenclature[0].value}/${nomenclature[1].value}`,
      icon: "fa fa-plus",
      command: () => setVisible(true),
    },
    ...(permissions && permissions.includes("94")
      ? [
        //Cadastro Quadra e Lote por Planilha
        {
          label: "Baixar Planilha Modelo",
          icon: "fa fa-solid fa-download",
          command: () => requestFile(),
        },
        {
          label: "Cadastrar por Planilha",
          icon: "fa fa-upload",
          color: "success",
          // disabled: schedules?.some(
          //   (schedule) => schedule.type === "excel_lands"
          // ),
          command: () =>
            handleOption(
              `Planilha de Cadastro de ${nomenclature[1].value}`,
              "lands"
            ),
        },
      ]
      : []),
    ...(permissions && permissions.includes("95")
      ? [
        //Atualização Lote por Planilha
        {
          label: `Exportar ${nomenclature[1].value}(s) para Atualização`,
          icon: "fa fa-cloud",
          command: () => exportToExcel(),
        },
        {
          label: `Atualizar ${nomenclature[1].value}(s) por Planilha`,
          icon: "fa fa-upload",
          color: "success",
          disabled: schedules?.some(
            (schedule) => schedule.type === "excel_lands_update"
          ),
          command: () =>
            handleOption(
              `Atualização de ${nomenclature[1].value}(s)`,
              "lands_update"
            ),
        },
      ]
      : []),
  ];

  async function requestFile() {
    var a = document.createElement("a");
    a.href =
      "https://walletlote-arquivos.s3.amazonaws.com/ibsystem/modelo_quadra_lote.xlsx";
    a.click();
  }

  function buildErrorMessage(errorMessages) {
    let message = "";
    for (const line in errorMessages) {
      if (errorMessages.hasOwnProperty(line)) {
        message += `Linha ${line}: ${errorMessages[line]} | `;
      }
    }
    return message;
  }

  const parseNumber = value => {
    if (!value) return "";
    const cleaned = String(value).replace(",", ".").replace(/[^0-9.]/g, "");
    const num = parseFloat(cleaned);

    return isNaN(num) ? "" : num;
  };

  const transformJsonLands = (jsonData) => {
    // console.log(jsonData)
    return jsonData.slice(4).map((row) => {
      return {
        block_name: row["TABELA PARA CADASTRO DE LOTES"] || "",
        land_name: row["__EMPTY"] || "",
        m2: row["__EMPTY_1"] ? row["__EMPTY_1"].toString().replace(",", ".") : "",
        value: parseCurrency(row["__EMPTY_2"]) || 0,
        status: row["__EMPTY_3"] !== undefined && row["__EMPTY_3"] !== "" ? row["__EMPTY_3"] : "",

        address: row["__EMPTY_4"] || "",
        num_register: row["__EMPTY_5"] || "",
        city_hall_register: row["__EMPTY_6"] || "",
        descriptive_memorial: row["__EMPTY_7"] || "",
        front_measurement: parseNumber(row["__EMPTY_8"]),
        bottom_measurement: parseNumber(row["__EMPTY_9"]),
        right_measurement: parseNumber(row["__EMPTY_10"]),
        left_measurement: parseNumber(row["__EMPTY_11"]),
        corner_measurement: parseNumber(row["__EMPTY_12"]),
        front_confrontation: row["__EMPTY_13"] || "",
        bottom_confrontation: row["__EMPTY_14"] || "",
        right_confrontation: row["__EMPTY_15"] || "",
        left_confrontation: row["__EMPTY_16"] || "",
        others_confrontation: row["__EMPTY_17"] || "",
        obs: row["__EMPTY_18"] || "",
        reason_for_blocking: row["__EMPTY_19"] || "",
        rowNum: row["__rowNum__"] + 1,
      };
    });
  };
  const transformJsonUpdate = (jsonData) => {
    // console.log(jsonData);
    return jsonData.slice(3).map((row) => {
      return {
        idLand: row["ID"],
        block_name:
          row[
          "Essa planilha suporta até 10.000 (Dez mil) Linhas, e todos os campos com asterisco(*) são OBRIGATÓRIOS !"
          ] || "",
        land_name: row["__EMPTY"] || "",
        m2: row["__EMPTY_1"] ? row["__EMPTY_1"].toString().replace(",", ".") : "",
        value: parseCurrency(row["__EMPTY_2"]) || "",
        status: row["__EMPTY_3"] !== undefined && row["__EMPTY_3"] !== "" ? row["__EMPTY_3"] : "",

        address: row["__EMPTY_4"] || "",
        num_register: row["__EMPTY_5"] || "",
        city_hall_register: row["__EMPTY_6"] || "",
        front_measurement: parseNumber(row["__EMPTY_7"]),
        bottom_measurement: parseNumber(row["__EMPTY_8"]),
        right_measurement: parseNumber(row["__EMPTY_9"]),
        left_measurement: parseNumber(row["__EMPTY_10"]),
        corner_measurement: parseNumber(row["__EMPTY_11"]),
        front_confrontation: row["__EMPTY_12"] || "",
        bottom_confrontation: row["__EMPTY_13"] || "",
        right_confrontation: row["__EMPTY_14"] || "",
        left_confrontation: row["__EMPTY_15"] || "",
        others_confrontation: row["__EMPTY_16"] || "",
        obs: row["__EMPTY_17"] || "",
        descriptive_memorial: row["__EMPTY_18"] || "",
        reason_for_blocking: row["__EMPTY_19"] || "",
        rowNum: row["__rowNum__"] + 1,
      };
    });
  };

  const handleFileChange = async (event) => {
    setVisibleFileInput(false);
    const notification = toast.loading(
      "Enviando seus dados, por favor aguarde..."
    );

    const base64Data = selectedFile;

    // Função para converter base64 para ArrayBuffer
    const base64ToArrayBuffer = (base64) => {
      const binaryString = window.atob(base64.split(",")[1]); // Remove o prefixo "data:application/vnd..."
      const len = binaryString.length;
      const bytes = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      return bytes.buffer;
    };

    const arrayBuffer = base64ToArrayBuffer(base64Data);
    try {
      // Usando XLSX para ler o ArrayBuffer e converter o Excel em JSON
      const workbook = XLSX.read(arrayBuffer, { type: "array" });

      // Pegando a primeira planilha
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Converte a planilha em JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      let transformedData;
      if (isFunctionSchedule === "lands") {
        transformedData = transformJsonLands(jsonData);
      } else {
        transformedData = transformJsonUpdate(jsonData);
      }
      // console.log(transformedData);
      // Monta o objeto a ser enviado ao backend
      const obj = {
        datas: transformedData,
        type_excel: isFunctionSchedule,
        enterprise_id: id,
      };
      // console.log(obj);
      const res = await postSchedulesExcel(obj);
      toast.update(notification, {
        render: "Planilha de Importação inserida com sucesso, acompanhe o status nas notificações",
        autoClose: 5000,
        type: "info",
        isLoading: false,
      });

    } catch (error) {
      const errorMessage =
        error.message || "Ocorreu um erro inesperado.";

      toast.update(notification, {
        render: errorMessage,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    }
    refetchSchedule();
    setSelectedFile([]);
  };

  const exportToExcel = async () => {
    setLoading(true);
    const notification = toast.loading("Por favor aguarde...");
    try {
      const response = await getAllLands(id);
      // console.log(response);

      const data = [
        [
          { v: "ID" },
          {
            v: "Essa planilha suporta até 10.000 (Dez mil) Linhas, e todos os campos com asterisco(*) são OBRIGATÓRIOS !",
            // s: { font: { sz: 9, bold: true, color: { rgb: "FF0000" } } },
          },
        ],
        [
          { v: "" },
          {
            v: "Para o campo STATUS, os valores disponíveis são: 0 para reservado, 1 para disponível, 2 para Vendido, 3 Bloqueado",
            // s: { font: { sz: 9, bold: true, color: { rgb: "FF0000" } } },
          },
        ],
        [
          { v: "" },
          {
            v: "ATENÇÃO: É explicitamente PROIBIDO alterar a coluna (A), em caso de alteração, seu sistema apresentará danos irreparáveis",
            // s: { font: { sz: 9, bold: true, color: { rgb: "FF0000" } } },
          },
        ],
        [
          "ID",
          nomenclature[0].value + "*",
          nomenclature[1].value + "*",
          "M²*",
          "Valor*",
          "Status*",
          "Endereço",
          "Matricula",
          "Cadastro Prefeitura",
          "Metragem Frente",
          "Metragem Fundo",
          "Metragem Direita",
          "Metragem Esquerda",
          "Metragem Esquina",
          "Confrontação Frente",
          "Confrontação Fundo",
          "Confrontação Direita",
          "Confrontação Esquerda",
          "Confrontação Outros",
          "Obsercação",
          "Memorial",
          "Motivo do Bloqueio"
        ],
      ];

      response.forEach((item) => {
        data.push([
          item.id,
          item.block,
          item.land,
          item.m2,
          formatCurrency(item.value),
          item.status,
          item.address,
          item.num_register,
          item.city_hall_register,
          item.front_measurement,
          item.bottom_measurement,
          item.right_measurement,
          item.left_measurement,
          item.corner_measurement,
          item.front_confrontation,
          item.bottom_confrontation,
          item.right_confrontation,
          item.left_confrontation,
          item.others_confrontation,
          item.obs,
          item.descriptive_memorial,
          item.reason_for_blocking
        ]);
      });

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(data);

      ws["!cols"] = [
        {
          formatCells: false,
          formatColumns: false,
          formatRows: false,
          // cellStyles: true,
        },
      ];

      XLSX.utils.book_append_sheet(wb, ws, "atualizacao_quadra_lote");
      XLSX.writeFile(wb, `atualizacao_quadra_lote.xlsx`);
      setLoading(false);
      toast.update(notification, {
        render: "Consulta realizada!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      setLoading(false);
      if (notification) {
        toast.update(notification, {
          render: "Hm..Algo não ocorreu bem.",
          autoClose: 1000,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
      }
    }
  };

  useEffect(() => {
    if (lands) {
      // console.log(lands);
      const dataWithoutIds = lands.map((t) => {
        let labelText = "";
        switch (t.status) {
          case 1:
            labelText = "Disponível";
            break;
          case 2:
            labelText = "Vendido";
            break;
          case 0:
            labelText = "Reservado";
            break;
          case 3:
            labelText = "Bloqueado";
            break;
          default:
            labelText = "Indefinido"; // valor padrão caso não corresponda a nenhum caso
        }
        return {
          IDLote: t.id,
          Quadra: t.block,
          Lote: t.land,
          Metragem: t.metro,
          Valor: t.value,
          Status: labelText, // agora com valor correto
          Observacao: t.obs,
        };
      });
      // console.log("sem ids", dataWithoutIds);
      setTableToExport(dataWithoutIds);
    }
  }, [lands]);

  return (
    <>
      <div className="row d-flex justify-content-between mb-3">
        <div className="row p-0">
          <div className="col-md-4">
            <BreadCrumb
              model={items}
              home={home}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "16px",
              }}
            />
          </div>

          <Modal
            visible={visibleFileInput}
            dynamicTitle={modalTitle}
            onHide={(e) => setVisibleFileInput(false)}
          >
            <FileInput
              isMultiple={false}
              selectedFile={selectedFile}
              setSelectedFile={setSelectedFile}
              onConfirmButton={handleFileChange}
              buttonConfirm={true}
              type="file"
              base64={true}
              typeFile=".xlsx,.xls"
              name="excelUpload"
              id="excelUpload"
              title="Inserir Planilha"
              icon="fa-rotate-left"
            />
          </Modal>
          <div className="col-md-8 text-end p-0">
            <div className="row justify-content-end pb-3">
              {showTable && (
                <>
                  {permissions &&
                    permissions.includes("96") && ( // Excluir Quadra e Lote
                      <div className="col-md-3">
                        <SplitButton
                          label="Excluir"
                          icon="fa fa-close"
                          model={nomenclature}
                          rounded
                          severity="danger"
                          className="w-100 pb-2"
                        />
                      </div>
                    )}
                  {permissions &&
                    permissions.includes("98") && ( // Editar Status Lote
                      <div className="col-md-3">
                        <SplitButton
                          label="Status"
                          icon="fa fa-edit"
                          model={OptionStatus}
                          disabled={selectedCustomers.length === 0}
                          rounded
                          className="w-100 pb-2"
                        />
                      </div>
                    )}
                  {permissions &&
                    permissions.includes("99") && ( // Editar Preço Lote
                      <div className="col-md-3">
                        <SplitButton
                          label="Preço"
                          icon="fa fa-edit"
                          model={OptionPrice}
                          disabled={selectedCustomers.length === 0}
                          rounded
                          className="w-100 pb-2"
                        />
                      </div>
                    )}
                </>
              )}
              {permissions &&
                permissions.includes("93") && ( // Cadastrar Quadra e Lote
                  <div className="col-md-3">
                    <SplitButton
                      label="Cadastrar"
                      severity="success"
                      icon="fa fa-plus"
                      model={spreadsheet}
                      rounded
                      className="w-100 pb-2 meuComponente"
                      onClick={() => setVisible(true)}
                    />
                  </div>
                )}
            </div>
          </div>
        </div>
        <Panel
          title={`Cadastro de ${nomenclature[0].value} e ${nomenclature[1].value}`}
        >
          <div className="row d-flex mt-4">
            <div className="col-md-11 mb-3 form-group">
              <span className="p-float-label">
                <Dropdown
                  inputId="dd-city"
                  label={
                    isLoadingBlocks
                      ? "Carregando.."
                      : `${nomenclature[0].value}`
                  }
                  value={
                    isLoadingBlocks ? "" : selectedBlock ? selectedBlock : 0
                  }
                  onChange={(e) => setSelectedBlock(e.value)}
                  options={
                    blocks && [
                      { value: 0, label: "Todos" },
                      ...Object.keys(blocks).map((index) => {
                        const dado = blocks[index];
                        return {
                          value: dado.id,
                          label: dado.name,
                        };
                      }),
                    ]
                  }
                  optionLabel="label"
                  className="w-100"
                  disabled={isLoadingBlocks ? true : false}
                />
                <label htmlFor="dd-city">
                  {isLoadingBlocks
                    ? "Carregando.."
                    : `${nomenclature[0].value}`}
                </label>
              </span>
            </div>
            <div className="col-md-1 h-100 form-group">
              <div className="text-center">
                <Button
                  icon="fa fa-search"
                  loading={loading}
                  disabled={disabled}
                  aria-label="Search"
                  className={`rounded-3 py-2.5 w-100`}
                  onClick={getLand}
                />
              </div>
            </div>
          </div>
        </Panel>
        {showTable && (
          <Panel mainCss="mt-4">
            <>
              <div className="px-2 pb-3">
                <ExportTable
                  tableData={tableToExport}
                  exportColumns={exportColumns}
                  tabelaKey={`${nomenclature[1].value}`}
                  globalFilterValue={globalFilterValue}
                  onGlobalFilterChange={onGlobalFilterChange}
                />

                <DataTable
                  rows={25}
                  paginator
                  stripedRows
                  showGridlines
                  sortMode="multiple"
                  selectionMode="multiple"
                  rowsPerPageOptions={[5, 25, 100]}
                  value={lands}
                  totalRecords={lands}
                  // loading={loading}
                  selectAll={selectAll}
                  selection={selectedCustomers}
                  footerColumnGroup={footerGroup}
                  onSelectionChange={onSelectionChange}
                  onSelectAllChange={onSelectAllChange}
                  globalFilter={globalFilterValue}
                  emptyMessage="Nenhuma Informação foi encontrada."
                  tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
                >
                  <Column
                    field="id"
                    headerStyle={{ width: "3rem" }}
                    selectionMode="multiple"
                    filterMatchMode={FilterMatchMode.CONTAINS}
                  />
                  {columns.map((col) => (
                    <Column
                      sortable
                      key={col.field}
                      field={col.field}
                      header={col.header}
                      filterMatchMode={FilterMatchMode.CONTAINS}
                      body={col.body}
                    />
                  ))}
                  {permissions &&
                    permissions.includes("97") && ( // Editar Lote
                      <Column
                        header={`Editar ${nomenclature[1].value}`}
                        body={(rowData) => (
                          <div className="text-center">
                            <button
                              className="btn btn-success btn-btn-sm"
                              onClick={() => SubmitEditLand(rowData)}
                            >
                              <i className="fa-solid fa-pen-to-square"></i>
                            </button>
                          </div>
                        )}
                      />
                    )}
                </DataTable>
              </div>
            </>
          </Panel>
        )}
        <ModalCreateLands
          visible={visible}
          headerModal={headerModal}
          handleCloseModal={() => setVisible(false)}
          blocks={blocks}
          refetch={blocksRefetch}
          refresh={refetchBlock}
          registerBlock={registerBlock}
          setRegisterBlock={setRegisterBlock}
          isLoading={isLoadingBlocks}
          setVisible={setVisible}
        />
        <ModalEditLands
          visible={visibleEditModal}
          headerModal={headerEditModal}
          handleCloseModal={handleCloseEditModal}
          rowData={sendRowData}
          getLands={getLands}
          land={land}
          loading={loadingModal}
          lands={lands}
          setLands={setLands}
          refetch={blocksRefetch}
          refresh={refetchBlock}
          investor={investors}
          fileSelected={fileSelected}
          setFileSelected={setFileSelected}
          setVisible={setVisibleEditModal}
        />
        <ModalDeleteBlocks
          visible={visibleDeleteModal}
          headerModal={headerDeleteModal}
          handleCloseModal={handleCloseDeleteModal}
          whiteBlocks={whiteBlocks}
          refetch={blocksRefetch}
          refresh={refetchBlock}
          setVisible={setVisibleDeleteModal}
          enterpriseId={id}
        />
        {isModalVisible && (
          <Modal
            visible={isModalVisible}
            position="top"
            onHide={() => setIsModalVisible(false)}
            dynamicTitle={selectedOptionTitle}
          >
            <div className="px-3 pt-5">
              <form onSubmit={form.handleSubmit(handleCalculateValue)}>
                <div className="row">
                  <div className="col-md-12">
                    <NumberInput
                      suffix={selectedOptionPrefix === "percen" ? "%" : null}
                      max={selectedOptionPrefix === "percen" ? 100 : null}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      name="value_selecionado"
                      control={form.control}
                      label={selectedOptionLabel}
                      getFormErrorMessage={getFormErrorMessage}
                      min={0}
                      className="w-100"
                      error={errors}
                      {...(selectedOptionPrefix === "reais" && {
                        mode: "currency",
                        currency: "BRL",
                        locale: "pt-BR",
                      })}
                      useGrouping={true}
                      required={true}
                    />
                  </div>
                  <div className="pt-5 text-center">
                    <Button
                      rounded
                      loading={disabled}
                      label="Alterar"
                      type="submit"
                      icon="fa fa-solid fa-pen-to-square"
                      onClick={() => setVisible(false)}
                      className="p-inputtext-sm m-auto"
                    />
                  </div>
                </div>
              </form>
            </div>
          </Modal>
        )}
        <input
          type="file"
          name="excelUpload"
          id="excelUpload"
          onChange={handleFileChange}
          hidden
        />
      </div>
      <Modal
        visible={isVisibleReserve}
        dynamicTitle={
          modalType === "0"
            ? `Observação da Reserva`
            : modalType === "3"
              ? `Bloquear ${nomenclature[1].value}`
              : modalType === "1"
                ? "Desfazer Bloqueio/Reserva"
                : modalType === "2" && "Marcar Vendido"
        }
        onHide={() => setIsVisibleReserve(false)}
        closable={true}
      >
        <div className="pt-4 justify-content-center">
          <span className="p-float-label">
            <InputTextarea
              required={true}
              className="w-100"
              value={value}
              id="obs"
              onChange={(e) => setValue(e.target.value)}
              rows={5}
              cols={92}
            />
            <label htmlFor="obs">
              {modalType === "0"
                ? `Observação do Motivo da Reserva`
                : modalType === "3"
                  ? `Motivo do Bloqueio`
                  : modalType === "1"
                    ? "Motivo para Desfazer o Bloqueio/Reserva"
                    : modalType === "2" && "Motivo para Marcar Vendido"}
            </label>
          </span>
          <div className="pt-3 text-center">
            <Button
              type="submit"
              rounded
              label={"Salvar"}
              icon="fa fa-check"
              onClick={() => {
                confirm(modalType);
                setIsVisibleReserve(false);
              }}
              className="p-inputtext-sm m-auto"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}
